<ng-select
  [items]="languages"
  bindLabel="label"
  bindValue="code"
  [clearable]="false"
  [ngModel]="selectedLang()"
  (ngModelChange)="switchLanguage($event)"
  [searchable]="false"
>
  <ng-template ng-label-tmp let-item="item">
    <img [src]="item.flag" width="20" height="14" class="flag-icon" />
    <span></span>
  </ng-template>

  <ng-template ng-option-tmp let-item="item">
    <img [src]="item.flag" width="20" height="14" class="flag-icon" />
  </ng-template>
</ng-select>
